import { CommonModule, Location } from '@angular/common';
import { Component, Input, OnInit, Optional } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-light-svg-icons';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbDatepicker,
} from '@ng-bootstrap/ng-bootstrap';

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two
    ? false
    : one.year === two.year
    ? one.month === two.month
      ? one.day === two.day
        ? false
        : one.day < two.day
      : one.month < two.month
    : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two
    ? false
    : one.year === two.year
    ? one.month === two.month
      ? one.day === two.day
        ? false
        : one.day > two.day
      : one.month > two.month
    : one.year > two.year;

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  // providers: [
  //   { provide: MAT_DATE_FORMATS }
  // ],
  standalone: true,
  imports: [NgbDatepicker, CommonModule, FontAwesomeModule],
})
export class CalendarComponent implements OnInit {
  @Input() eventSelected: any;
  // Calendar
  optionsDates: any[] = [];

  selectedDate!: NgbDateStruct;
  numDaySelect!: number;
  dateDaySelect!: number;

  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;

  minDate!: NgbDateStruct;
  maxDate!: NgbDateStruct;
  currentMonth!: any;
  currentYear!: any;
  dateString: any;
  hoveredDate!: any;

  fromDate!: any;
  monthsOptions: any[] = [];

  fechasEvent!: any;
  now = new Date();
  firstWeek: any[] = [];

  loaded: boolean = false;

  constructor(
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private location: Location,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fechasEvent = this.eventSelected.fechas.find(
      (event: any) => event.activo == true
    );
    const date = new Date(this.fechasEvent.fechaInicio);

    const start = date < this.now ? this.now : date;
    const end = this.fechasEvent.fechaFin
      ? new Date(this.fechasEvent.fechaFin)
      : start;
    this.currentMonth = start.getMonth() + 1;
    this.currentYear = start.getFullYear();
    this.minDate = new NgbDate(
      start.getFullYear(),
      start.getMonth() + 1,
      start.getDate()
    );
    this.maxDate = new NgbDate(
      end.getFullYear(),
      end.getMonth() + 1,
      end.getDate()
    );

    if (this.fechasEvent.typeRepeat == 'week') {
      let first_day_week = new Date(this.fechasEvent.fechaInicio);
      let day_aux = first_day_week.getDay();
      let date_aux = new Date(first_day_week.toDateString());

      do {
        if (this.fechasEvent.repeatInterval.includes(day_aux)) {
          this.firstWeek.push({
            day_week: day_aux,
            date: new Date(date_aux.toDateString()),
          });
        }
        date_aux.setDate(date_aux.getDate() + 1);
        day_aux = date_aux.getDay();
      } while (day_aux < 6);
    }
    this.loaded = true;
  }

  isHovered(date: NgbDate) {
    return this.hoveredDate && date.before(this.hoveredDate);
  }
  isWeekend = (date: NgbDate) => this.calendar.getWeekday(date) >= 6;

  changeDateSelected(date: NgbDate) {
    if (!this.dayDisabled(date)) {
      this.dateString = this.formatter.format(date);
      this.selectedDate = date;
      this.numDaySelect = new Date(this.dateString).getDay();
      this.dateDaySelect = new Date(this.dateString).getDate();

      localStorage.setItem(
        'dateEvent',
        new Date(date.year, date.month - 1, date.day + 1).toISOString()
      );

      localStorage.setItem('dateString', this.dateString);
      localStorage.setItem('selectedDateYear', String(this.selectedDate.year));
      localStorage.setItem(
        'selectedDateMonth',
        String(this.selectedDate.month)
      );
      localStorage.setItem('selectedDateDay', String(this.selectedDate.day));
      localStorage.setItem('numDaySelect', String(this.numDaySelect));
      localStorage.setItem('dateDaySelect', String(this.dateDaySelect));
    }
  }

  dayDisabled(date: NgbDateStruct) {
    let stringDate = this.formatter.format(date);
    const dateNew = new Date(stringDate);
    return (
      before(date, this.minDate) ||
      (this.fechasEvent.repeat && !this.isActive(date, dateNew)) ||
      after(date, this.maxDate)
    );
  }

  isActive(date: NgbDateStruct, dateNew: Date) {
    if (
      this.fechasEvent.typeRepeat == 'week' &&
      this.fechasEvent.repeatInterval.includes(dateNew.getDay())
    ) {
      const date_current_day = this.firstWeek.find((value) => {
        return value.day_week == dateNew.getDay();
      });
      const aux_count = 7 * this.fechasEvent.repeatCount;
      let rest = Math.floor(
        (dateNew.getTime() - date_current_day.date.getTime()) /
          (1000 * 60 * 60 * 24)
      );
      return rest % aux_count == 0;
    }
    if (
      this.fechasEvent.typeRepeat == 'month' &&
      this.fechasEvent.repeatInterval.includes(date.day)
    ) {
      return true;
    }
    if (
      this.fechasEvent.typeRepeat == 'year' &&
      date.day == this.minDate.day &&
      date.month == this.minDate.month
    ) {
      return true;
    }
    return false;
  }

  navigate(datepicker: NgbDatepicker, number: number) {
    const { state, calendar } = datepicker;
    datepicker.navigateTo(calendar.getNext(state.firstDate, 'm', number));
  }

  goTickets() {
    this.router.navigate(['event/tickets/' + this.eventSelected.id]);
  }

  goBack() {
    this.location.back();
  }
}
